import React from 'react'

import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import { useMobile } from 'emt-components-v2'
import { ProfileSidebar } from './StyledComponents'
import ProfileSidebarStickyCard, {
  ProfileSideBarUserCard,
} from '@/components/Profile/partials/ProfileSidebarStickyCard'
import ContactButton from './ProfileSidebar/ContactButton'
import FavoriteButton from '@/components/Profile/partials/ProfileSidebar/FavoriteButton'

type Props = React.PropsWithChildren<{
  profile: ProfileSideBarUserCard
  activeStickyProfile: boolean
  isLoaded: boolean
  onContactButtonClick: () => void | Promise<void>
  isFavoriteLoading: boolean
  onFavoriteButtonClick: () => void | Promise<void>
}>

const ProfileSidebarComponent: React.FC<Props> = ({
  profile,
  activeStickyProfile,
  isLoaded,
  onContactButtonClick,
  onFavoriteButtonClick,
  isFavoriteLoading,
}) => {
  const [isMobile] = useMobile()

  return (
    <>
      {/* Desktop */}
      {!isMobile && isLoaded && (
        <ProfileSidebar id="profile-sidebar">
          {activeStickyProfile ? (
            <ProfileSidebarStickyCard
              profile={profile}
              onContactButtonClick={onContactButtonClick}
              isFavoriteLoading={isFavoriteLoading}
              onFavoriteButtonClick={onFavoriteButtonClick}
            />
          ) : isLoaded ? (
            <>
              <ContactButton onClick={onContactButtonClick} />
              <FavoriteButton
                onClick={onFavoriteButtonClick}
                loader={isFavoriteLoading}
                isFavorite={profile.isFavorite}
              />
            </>
          ) : (
            <>
              <Skeleton variant="rectangular" sx={{ height: 45, borderRadius: '16px' }} />
              <Skeleton variant="rectangular" sx={{ height: 45, borderRadius: '16px' }} />
            </>
          )}
        </ProfileSidebar>
      )}
      {/* END Desktop */}

      {/* Mobile */}
      {isMobile && isLoaded && (
        <Box
          sx={{
            position: 'fixed',
            display: 'flex',
            gap: '8px',
            bottom: '30px',
            left: '5%',
            width: '90%',
            zIndex: 12000,
            whiteSpace: 'nowrap',
          }}
          className="EmtReactNativeWebViewPaddingBottom"
        >
          <ContactButton sx={{ fontSize: '14px' }} onClick={onContactButtonClick} />
          <FavoriteButton
            sx={{ fontSize: '14px', textOverflow: 'ellipsis' }}
            onClick={onFavoriteButtonClick}
            loader={isFavoriteLoading}
            isFavorite={profile.isFavorite}
          />
        </Box>
      )}
      {/* END Mobile */}
    </>
  )
}

export default ProfileSidebarComponent
